import {
  VideoMaxAdDurationTargeting,
  type VideoMaxAdDurationTargetingType,
} from '@openx/types/targeting/targetingValuesTypes.ts';
import type { MaxAdDurationStatePayload } from '@openx/types/targeting/video.ts';
import { useCallback, useMemo, useState } from 'react';
import { DurationSelection } from '../components/DurationSelection.tsx';
import { getSanitizedValue } from '../utils/getSanitizedValue.ts';

export const useMaxAdDuration = (
  value: MaxAdDurationStatePayload | null,
  onChange: (value: MaxAdDurationStatePayload | null) => void
) => {
  const [type, setType] = useState<VideoMaxAdDurationTargetingType>(value?.type ?? VideoMaxAdDurationTargeting.BETWEEN);

  const handleChange = useCallback(
    (newValue: Partial<MaxAdDurationStatePayload> | null) => {
      const start = getSanitizedValue(newValue?.start, value?.start);
      const end = getSanitizedValue(newValue?.end, value?.end);

      if (start === null && end === null) {
        onChange(null);
      } else {
        onChange({ start, end, type });
      }
    },
    [onChange, type, value?.start, value?.end]
  );

  const handleTypeChange = useCallback(
    (newType: VideoMaxAdDurationTargetingType) => {
      setType(newType);
      onChange(null);
    },
    [onChange]
  );

  const durationSelection = useMemo(
    () => <DurationSelection type={type} value={value} onChange={handleChange} />,
    [handleChange, value, type]
  );

  return { type, durationSelection, handleTypeChange };
};
